// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2lkzO","sk-rotate":"Spinner_sk-rotate__3aR-T","dot1":"Spinner_dot1__3Af5X","dot2":"Spinner_dot2__1T4DA","sk-bounce":"Spinner_sk-bounce__3oB6s"};